import axios from "axios";
import Config from "../../config/";
import { encryptPayload } from "../../utils/encryption";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;


export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

export function encrypted(text) {
  return encryptPayload(text);
}

export function pushProfilewlist(
  id,
  email,
  name,
  gender,
  brithday,
  description,
  job,
  userlevel,
  picture_url
) {
  const url = `${ROOT_URL}api/userprofile/${id}`;

  const fdata = new FormData();
  fdata.append("id", encrypted(id));
  fdata.append("email", encrypted(email));
  fdata.append("name", encrypted(name));
  fdata.append("gender", encrypted(gender));
  fdata.append("brithday", encrypted(brithday));
  fdata.append("description", encrypted(description));
  fdata.append("login_type", encrypted(""));
  fdata.append("picture_background_url", encrypted(""));
  fdata.append("social_id", encrypted(""));
  fdata.append("job", encrypted(job));
  fdata.append("userlevel", encrypted(userlevel));

  if (picture_url != "") {
    fdata.append("picture_url", encrypted(picture_url));
  }

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushProfile(
  id,
  name,
  gender,
  brithday,
  description,
  job,
  picture_url,
  company_code
) {
  const url = `${ROOT_URL}api/profile/${id}/`;

  const fdata = new FormData();
  fdata.append("name", name);
  fdata.append("gender", gender);
  fdata.append("brithday", brithday);
  fdata.append("description", description);
  fdata.append("job", job);
  fdata.append("company_code", company_code);

  // if (picture_url != "") {
    fdata.append("picture_url", "-");
  // }

  const request = axios.patch(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function proccessUpload(fileupload) {
  const url = `${ROOT_URL}api/uploadphotoprofile/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushProfilePass() {
  return Promise.reject(
    new Error("Legacy password synchronization is disabled")
  );
}
